module.exports = __webpack_public_path__ + "img/waiting_for_me.d6d6a7cb.svg";